import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { resetStore } from "../app/actions";
import { useAppDispatch } from "../app/hooks";
import { anonymize } from "../features/analytics";

const SignOut = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // Preserve user preferences before signing out
    const darkModeEnabled = window.localStorage.getItem("evernow_ehr_dark_mode_enabled");

    anonymize();
    dispatch(resetStore());
    Sentry.setUser(null);

    // Restore preserved preferences after store reset
    if (darkModeEnabled !== null) {
      window.localStorage.setItem("evernow_ehr_dark_mode_enabled", darkModeEnabled);
    }

    navigate("/");
  }, [dispatch, navigate]);
  return null;
};

export default SignOut;
